import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const RoleBasedRedirect = () => {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    switch (user.role) {
        case 'HOSPITAL':
            return <Navigate to="/hms" replace />;
        case 'DOCTOR':
            return <Navigate to="/doctor" replace />;
        case 'GROOMING_AGENCY':
            return <Navigate to="/groomer" replace />;
        case 'ECOMMERCE_AGENT':
            return <Navigate to="/agent" replace />;
        case 'ADMIN':
            return <Navigate to="/admin" replace />;
        case 'PARTNER':
            return <Navigate to="/partner" replace />;
        case 'DAYCARE':
            return <Navigate to="/daycare-mgmt" replace />;
        case 'TRAINER':
            return <Navigate to="/trainer-mgmt" replace />;
        case 'NGO':
        case 'CSR':
            return <Navigate to="/csr/logistics?tab=overview" replace />;
        default: // OWNER
            return <Navigate to="/dashboard" replace />;
    }
};
